window.ensurePredictiveSearch = function ensurePredictiveSearch() {
  if (customElements.get('predictive-search')) {
    return Promise.resolve();
  }

  if (window.__predictiveSearchPromise) {
    return window.__predictiveSearchPromise;
  }

  window.__predictiveSearchPromise = new Promise(function (resolve, reject) {
    if (!window.__predictiveSearchAssetUrl) {
      reject(new Error('Missing predictive search asset URL'));
      return;
    }

    var script = document.createElement('script');
    script.src = window.__predictiveSearchAssetUrl;
    script.async = true;
    script.onload = function () {
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return window.__predictiveSearchPromise;
};

(function () {
  function shouldLoad(target) {
    return !!(
      target &&
      (target.closest('predictive-search') ||
        target.closest('[data-search-container]') ||
        target.matches('[data-search-icon], [data-search-icon-mobile]'))
    );
  }

  function triggerLoad() {
    window.ensurePredictiveSearch().catch(function () {});
  }

  document.addEventListener(
    'focusin',
    function (event) {
      if (shouldLoad(event.target)) triggerLoad();
    },
    true,
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (shouldLoad(event.target)) triggerLoad();
    },
    true,
  );
})();
